'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectMostRecentVenueSchedule = exports.showPurchaseModalError = exports.showPurchaseModal = exports.SHOW_PURCHASE_MODAL_ERROR = exports.SHOW_PURCHASE_MODAL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.getDefaultOffer = getDefaultOffer;
exports.doShowPurchaseModal = doShowPurchaseModal;
exports.watchPurchase = watchPurchase;

var _effects = require('redux-saga/effects');

var _sagaTools = require('@classpass/saga-tools');

var _bound = require('redux/saga/entities/bound');

var _modals = require('redux/modules/modals');

var _helpers = require('redux/saga/helpers');

var _multitrack = require('helpers/multitrack');

var _deep = require('helpers/deep');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(getDefaultOffer),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(doShowPurchaseModal),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(watchPurchase);

var SHOW_PURCHASE_MODAL = exports.SHOW_PURCHASE_MODAL = 'SHOW_PURCHASE_MODAL';
var SHOW_PURCHASE_MODAL_ERROR = exports.SHOW_PURCHASE_MODAL_ERROR = 'SHOW_PURCHASE_MODAL_ERROR';

var showPurchaseModal = exports.showPurchaseModal = function showPurchaseModal(scheduleId) {
  return { type: SHOW_PURCHASE_MODAL, scheduleId: scheduleId };
};
var showPurchaseModalError = exports.showPurchaseModalError = _helpers.errorActionCreator.bind(null, SHOW_PURCHASE_MODAL_ERROR);

var selectMostRecentVenueSchedule = exports.selectMostRecentVenueSchedule = function selectMostRecentVenueSchedule(state) {
  return _bound.scheduleForVenue.data(state, _bound.scheduleForVenue.lastLoadedKey(state));
};

var hasAlcPricing = function hasAlcPricing(schedule) {
  return schedule && schedule.availability && schedule.availability.purchase;
};

function getDefaultOffer(client, msaId, scheduleId) {
  var promotion;
  return _regenerator2.default.wrap(function getDefaultOffer$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.defaultPromotion, [client, 'alc', msaId]);

        case 3:
          promotion = _context.sent;
          return _context.abrupt('return', (0, _deep.deepExtract)('offers', promotion, []).reduce(function (top, current) {
            if (top) {
              return top.offer.priority < current.offer.priority ? top : current;
            }
            return current;
          }, null));

        case 7:
          _context.prev = 7;
          _context.t0 = _context['catch'](0);
          _context.next = 11;
          return (0, _effects.spawn)(_multitrack.ga, 'Membership Purchase', 'alc_checkout_trial_offer_unavailable', scheduleId, 0, { nonInteraction: true });

        case 11:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 7]]);
}

function doShowPurchaseModal(client, _ref) {
  var scheduleId = _ref.scheduleId;
  var schedule, venueSchedule, msaId, offer;
  return _regenerator2.default.wrap(function doShowPurchaseModal$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;

          // Try to get the schedule from the most recently loaded venue schedule.
          schedule = void 0;
          _context2.next = 4;
          return (0, _effects.select)(selectMostRecentVenueSchedule);

        case 4:
          venueSchedule = _context2.sent;

          schedule = venueSchedule && venueSchedule.schedules && venueSchedule.schedules.find(function (_ref2) {
            var id = _ref2.id;
            return id === scheduleId;
          });

          // Re-fetch by id if the schedule isn't there or if it doesn't contain pricing info.

          if (hasAlcPricing(schedule)) {
            _context2.next = 10;
            break;
          }

          _context2.next = 9;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.scheduleById, [client, scheduleId, { alc: true }]);

        case 9:
          schedule = _context2.sent;

        case 10:
          if (hasAlcPricing(schedule)) {
            _context2.next = 12;
            break;
          }

          throw new Error('Could not get ALC pricing info for schedule ' + scheduleId);

        case 12:
          msaId = schedule && schedule.venue.location.msa_id;
          _context2.next = 15;
          return (0, _effects.call)(getDefaultOffer, client, msaId, scheduleId);

        case 15:
          offer = _context2.sent;
          _context2.next = 18;
          return (0, _effects.put)((0, _modals.showModal)('PurchaseModal', { schedule: schedule, offer: offer }));

        case 18:
          _context2.next = 24;
          break;

        case 20:
          _context2.prev = 20;
          _context2.t0 = _context2['catch'](0);
          _context2.next = 24;
          return (0, _effects.put)(showPurchaseModalError(_context2.t0));

        case 24:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 20]]);
}

function watchPurchase(client) {
  return _regenerator2.default.wrap(function watchPurchase$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, SHOW_PURCHASE_MODAL, doShowPurchaseModal, client);

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}